import { Action, createAction } from '@reduxjs/toolkit';
import * as actionTypes from './actionTypes';

export const setForm = createAction<{
  field: FlattenKeys<DataForm>;
  value: any;
}>(actionTypes.SET_FORM_FIELD);

export const blurForm = createAction<{
  field: FlattenKeys<BlurForm>;
  value: any;
}>(actionTypes.BLUR_FORM_FIELD);

export const resetForm = createAction<void>(actionTypes.RESET_FORM);

const formActions = (dispatch: <T>(action: Action) => T) =>
  Object.assign(
    {},
    {
      setForm: <T extends FlattenKeys<DataForm>>(
        field: T,
        value: DeepType<DataForm, T>,
      ) => dispatch<void>(setForm({ field, value })),
      blurForm: <T extends FlattenKeys<BlurForm>>(payload: {
        field: T;
        value: DeepType<BlurForm, T>;
      }) => dispatch<void>(blurForm(payload)),
      resetForm: () => dispatch<void>(resetForm()),
    },
  );

export default formActions;
